import { render, staticRenderFns } from "./NoItems.vue?vue&type=template&id=371ca9f0&scoped=true&"
import script from "./NoItems.vue?vue&type=script&lang=js&"
export * from "./NoItems.vue?vue&type=script&lang=js&"
import style0 from "./NoItems.vue?vue&type=style&index=0&id=371ca9f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371ca9f0",
  null
  
)

export default component.exports